import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { setGlobalLoading } from 'redux/actions/actionCommon';
import { connect } from 'react-redux';
import FreeShipping from './ShippingForms/FreeShipping';
import FlatRateShipping from './ShippingForms/FlatRateShipping';
import CustomShipping from './ShippingForms/CustomShipping';
import ConditionalShipping from './ShippingForms/ConditionalShipping';

function Step3(props) {
    const { shipping, addShipping_, loading, countries, disableButton } = props

    return (
        <React.Fragment>
            <section id="app-product-filters" className="page-eorc-wrapper" style={{ position: "relative", top: "-46px", paddingBottom: 0 }}>
                <Container fluid className="st-container">
                    <div className="app-product-filters">
                        <Row className="product-filter-left-content">
                            <Col lg={9} md={12} className="product-filter-right-content">
                                {shipping.shipping_type === "free_shipping" && <FreeShipping
                                    shipping={shipping}
                                    addShipping_={addShipping_}
                                    loading={loading}
                                    countries={countries}
                                    disableButton={disableButton}
                                />}

                                {shipping.shipping_type === "flat_rate" && <FlatRateShipping
                                    shipping={shipping}
                                    addShipping_={addShipping_}
                                    loading={loading}
                                    countries={countries}
                                    disableButton={disableButton}
                                />}

                                {shipping.shipping_type === "custom_rates" && <CustomShipping
                                    shipping={shipping}
                                    addShipping_={addShipping_}
                                    loading={loading}
                                    countries={countries}
                                    disableButton={disableButton}
                                />}
                                {shipping.shipping_type === "conditional_free_shipping" && <ConditionalShipping
                                    shipping={shipping}
                                    addShipping_={addShipping_}
                                    loading={loading}
                                    countries={countries}
                                    disableButton={disableButton}

                                />}
                                {/* {shipping.shipping_type === "Automatically" && <AutomaticShipping
                                    shipping={shipping}
                                    addShipping_={addShipping_}
                                    loading={loading}
                                    countries={countries}
                                />} */}
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section>
        </React.Fragment >
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(Step3)